import {
  MENTOR_REPLY_TIME,
  type Subscription
} from '@algoacademy/backend/modules/marketplace/enums'
import type { IndividualMentoringProductDTO } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto'
import { ORDER_TYPE } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/types'
import type { GetAllBookingsForMonthOutputDTO } from '@algoacademy/backend/modules/phone-call-booking/endpoints/queries/get-all-bookings-for-month/output.dto'
import { type Dispatch, type SetStateAction, useEffect, useState } from 'react'
import {
  DEFAULT_HOURS_WITH_MENTOR,
  MAXIMUM_HOURS_WITH_MENTOR,
  MINIMUM_HOURS_WITH_MENTOR
} from '../../../prices'

type MentoringDetails = GetAllBookingsForMonthOutputDTO['bookings'][number]['mentoringDetails']

export function getDefaultIndividualProduct(
  subscription: Subscription
): IndividualMentoringProductDTO {
  return {
    order: ORDER_TYPE.INDIVIDUAL_MENTORING,
    subscription,
    email: '',
    hoursWithMentor: DEFAULT_HOURS_WITH_MENTOR,
    mentorReplyTime: MENTOR_REPLY_TIME.STANDARD,
    name: 'Mentoring rozszerzony',
    quantity: 1
  }
}

type UseInitMentoringProductWithMentoringDetailsDataProps = {
  mentoringDetails?: MentoringDetails
  activeSubscriptionTab: Subscription
}

export function useInitMentoringProductWithMentoringDetailsData({
  mentoringDetails,
  activeSubscriptionTab
}: UseInitMentoringProductWithMentoringDetailsDataProps): [
  IndividualMentoringProductDTO,
  Dispatch<SetStateAction<IndividualMentoringProductDTO>>
] {
  const [individualMentoringProduct, setIndividualMentoringProduct] =
    useState<IndividualMentoringProductDTO>(() =>
      getDefaultIndividualProduct(activeSubscriptionTab)
    )

  useEffect(() => {
    if (!mentoringDetails?.individualMentoringDetails || !mentoringDetails) {
      return
    }

    const details = mentoringDetails.individualMentoringDetails
    const rawHours = details.hoursWithMentor ?? DEFAULT_HOURS_WITH_MENTOR
    const hoursWithMentor = Math.min(
      Math.max(rawHours, MINIMUM_HOURS_WITH_MENTOR),
      MAXIMUM_HOURS_WITH_MENTOR
    )

    setIndividualMentoringProduct(prev => ({
      ...prev,
      subscription: activeSubscriptionTab,
      hoursWithMentor,
      mentorReplyTime: MENTOR_REPLY_TIME.STANDARD
    }))
  }, [mentoringDetails, activeSubscriptionTab])

  return [individualMentoringProduct, setIndividualMentoringProduct]
}
